import HealthManagerDeathsavesMarkManager from "./HealthManagerDeathsavesMarkManager";

export default HealthManagerDeathsavesMarkManager;
export { HealthManagerDeathsavesMarkManager };
